var nurseslounge_myDashboard_accountSettings = {
    init:function($params){
        $('.offcanvas-collapse').removeClass('open');
        $("footer").show();
        var $userId = libs.memoryGet('user_id');
        $params = $.extend({}, $params, {user_id:$userId});
        if($userId != 'guest') {
            nurseslounge_myDashboard_accountSettings.menu($params);
            nurseslounge_myDashboard_accountSettings.coins($params);
            nurseslounge_myDashboard_accountSettings.shop($params);
        }
        nurseslounge_myDashboard_thoughtLeadersForm.init($params);
        nurseslounge_myDashboard_manageMyCompany.init($params);
        nurseslounge_myDashboard_accountSettings.mobile();
    },
    menu:function($params){
        var $topNav = $("#topNav");
        var $deleteMyAccountModal = $("#nurseslounge-home-delete-my-account-modal");
        var $accountSettingModal = $("#nurseslounge-home-configuration-modal");
        var $password = $accountSettingModal.find('input[name="password"]');
        var $rePassword = $accountSettingModal.find('input[name="re_password"]');
        var $accountSettings = $topNav.find('.account-settings:first');
        var $dashboardSettings = $topNav.find('.dashboard-settings:first');
        var $deleteMyAccount = $topNav.find('.delete-my-account:first');
        var $logoutSettings = $topNav.find('.logout-settings:first');
        var $administratorSettings = $topNav.find('.administrator-settings:first');
        $administratorSettings.unbind().click(function(){
            window.location = '/administrator';
        });
        $logoutSettings.unbind().click(function(){
            window.location = '/logout';
        });
        $dashboardSettings.unbind().click(function(){
            nurseslounge_myDashboard_myProfile.profile_is_complete($params, true, function(){
                nurseslounge_myDashboard_myProfile.user_profile_fill($params, true);
            });
        });
        $accountSettings.unbind().click(function () {
                nurseslounge_myDashboard_accountSettings.configuration_dashboard_getSet($params, function ($data) {
                    //var $switchTalentPool = $data.data.switch.talent_pool;
                    var $emailNotifications = $data.data.switch.unsubscribe_email_notifications == 0 ? 'On' : 'Off';
                    var $notificationsWindow = $data.data.switch.disable_notifications_window == 0 ? 'On' : 'Off';
                    var $notificationsSound = $data.data.switch.disable_notifications_sound == 0 ? 'On' : 'Off';
                    var $disableDismissList = $data.data.switch.disable_dismiss_list == 0 ? 'Off' : 'On';
                    var $digestEmail = $data.data.switch.digest_email == 0 ? 'Off' : 'On';
                    //var $talentPool = $data.data.talent_pool;
                    var $values = $data.data.values;
                    var $catalogsLength = Object.keys($data.data.catalogs).length;
                    var $index = 0;
                    $.each($data.data.catalogs, function ($i, $v) {
                        $index++;
                        var $name = libs.snakeToCamel($i);
                        var $chtml = '';
                        $.each($v, function ($sI, $sV) {
                            if ($data.data.selected[$i] == $sI) {
                                $chtml += '<option value="' + $sI + '" selected="selected">' + $sV + '</option>';
                            } else {
                                $chtml += '<option value="' + $sI + '">' + $sV + '</option>';
                            }
                        });
                        if ($catalogsLength > $index) {
                            $accountSettingModal.find('form select[name="' + $name + '"]').html($chtml);
                        } else {
                            $accountSettingModal.find('form select[name="' + $name + '"]').html($chtml).promise().done(function () {
                                $accountSettingModal.find('form input[name="email"]').val($values.email);
                                //$accountSettingModal.find('form input[name="talentPoolEnable"]').prop('checked', $switchTalentPool != 0);
                                $accountSettingModal.find('#emailNotificationsEnable' + $emailNotifications).prop("checked", true);
                                $accountSettingModal.find('#notificationsWindow' + $notificationsWindow).prop('checked', true);
                                $accountSettingModal.find('#notificationsSound' + $notificationsSound).prop('checked', true);
                                $accountSettingModal.find('#disableDismissList' + $disableDismissList).prop('checked', true);
                                $accountSettingModal.find('#digestEmail' + $digestEmail).prop('checked', true);
                                var $digestEmailInput = $accountSettingModal.find('input[name="digestEmail"]');
                                var $digestEmailSchedulesWrapper = $accountSettingModal.find(".digest-email-schedules-wrapper");
                                var $digestEmailSchedules = $accountSettingModal.find('select[name="digestEmailSchedules"]');
                                var $digestEmailScheduleDaysWrapper = $accountSettingModal.find(".digest-email-schedule-days-wrapper");
                                var $digestEmailScheduleStartAtWrapper = $accountSettingModal.find(".digest-email-schedule-start-at-wrapper");
                                var $digestEmailScheduleTimeZone = $accountSettingModal.find('select[name="digestEmailScheduleTimeZone"]');
                                var $digestEmailScheduleTimeZoneWrapper = $accountSettingModal.find(".digest-email-schedule-time-zone-wrapper");
                                var $digestEmailScheduleWeeklyWrapper = $accountSettingModal.find(".digest-email-schedule-weekly-wrapper");
                                var $digestEmailScheduleWeeklyInput = $digestEmailScheduleWeeklyWrapper.find('input[name="digestEmailScheduleWeekly"]');
                                var $weeklyDays = $digestEmailScheduleWeeklyWrapper.find('.weekly_days');
                                var $timeZoneChtml = '' +
                                    '<div class="col-sm-12">' +
                                    '    <div class="input-group date" id="digest-email-schedule-start-at-wrapper" data-target-input="nearest" data-value="">' +
                                    '        <input type="text" name="digestEmailScheduleStartAt" class="form-control datetimepicker-input validate" data-target="#digest-email-schedule-start-at-wrapper">' +
                                    '        <div class="input-group-append" data-target="#digest-email-schedule-start-at-wrapper" data-toggle="datetimepicker">' +
                                    '            <div class="input-group-text">' +
                                    '                <i class="fa fa-clock-o"></i>' +
                                    '            </div>' +
                                    '        </div>' +
                                    '    </div>' +
                                    '</div>';


                                var $digestEmailSchedulesVal = $digestEmailSchedules.val();
                                $digestEmailInput.unbind().change(function(){
                                    var $that = $(this);
                                    $digestEmailSchedulesWrapper.hide();
                                    $digestEmailScheduleDaysWrapper.hide();
                                    $digestEmailScheduleWeeklyWrapper.hide();
                                    $digestEmailScheduleTimeZoneWrapper.hide();
                                    $digestEmailScheduleStartAtWrapper.hide();
                                    if($that.val() == 'on'){
                                        switch($digestEmailSchedulesVal){
                                            case 'daily':
                                                $digestEmailSchedulesWrapper.show();
                                                $digestEmailScheduleDaysWrapper.hide();
                                                $digestEmailScheduleWeeklyWrapper.hide();
                                                $digestEmailScheduleTimeZoneWrapper.show();
                                                $digestEmailScheduleStartAtWrapper.show();
                                                break;
                                            case 'weekly':
                                                $digestEmailSchedulesWrapper.show();
                                                $digestEmailScheduleDaysWrapper.hide();
                                                $digestEmailScheduleWeeklyWrapper.show();
                                                $digestEmailScheduleTimeZoneWrapper.show();
                                                $digestEmailScheduleStartAtWrapper.show();
                                                break;
                                            case 'every_2_weeks':
                                                $digestEmailSchedulesWrapper.show();
                                                $digestEmailScheduleDaysWrapper.hide();
                                                $digestEmailScheduleWeeklyWrapper.show();
                                                $digestEmailScheduleTimeZoneWrapper.show();
                                                $digestEmailScheduleStartAtWrapper.show();
                                                break;
                                            case 'every_3_weeks':
                                                $digestEmailSchedulesWrapper.show();
                                                $digestEmailScheduleDaysWrapper.hide();
                                                $digestEmailScheduleWeeklyWrapper.show();
                                                $digestEmailScheduleTimeZoneWrapper.show();
                                                $digestEmailScheduleStartAtWrapper.show();
                                                break;
                                            case 'every_4_weeks':
                                                $digestEmailSchedulesWrapper.show();
                                                $digestEmailScheduleDaysWrapper.hide();
                                                $digestEmailScheduleWeeklyWrapper.show();
                                                $digestEmailScheduleTimeZoneWrapper.show();
                                                $digestEmailScheduleStartAtWrapper.show();
                                                break;
                                        }
                                    }
                                });


                                $digestEmailSchedules.unbind().change(function(){
                                    var $that = $(this);
                                    $digestEmailSchedulesWrapper.hide();
                                    $digestEmailScheduleDaysWrapper.hide();
                                    $digestEmailScheduleWeeklyWrapper.hide();
                                    $digestEmailScheduleTimeZoneWrapper.hide();
                                    $digestEmailScheduleStartAtWrapper.hide();
                                    switch($that.val()){
                                        case 'daily':
                                            $digestEmailSchedulesWrapper.show();
                                            $digestEmailScheduleDaysWrapper.hide();
                                            $digestEmailScheduleWeeklyWrapper.hide();
                                            $digestEmailScheduleTimeZoneWrapper.show();
                                            $digestEmailScheduleStartAtWrapper.show();
                                            break;
                                        case 'weekly':
                                            $digestEmailSchedulesWrapper.show();
                                            $digestEmailScheduleDaysWrapper.hide();
                                            $digestEmailScheduleWeeklyWrapper.show();
                                            $digestEmailScheduleTimeZoneWrapper.show();
                                            $digestEmailScheduleStartAtWrapper.show();
                                            break;
                                        case 'every_2_weeks':
                                            $digestEmailSchedulesWrapper.show();
                                            $digestEmailScheduleDaysWrapper.hide();
                                            $digestEmailScheduleWeeklyWrapper.show();
                                            $digestEmailScheduleTimeZoneWrapper.show();
                                            $digestEmailScheduleStartAtWrapper.show();
                                            break;
                                        case 'every_3_weeks':
                                            $digestEmailSchedulesWrapper.show();
                                            $digestEmailScheduleDaysWrapper.hide();
                                            $digestEmailScheduleWeeklyWrapper.show();
                                            $digestEmailScheduleTimeZoneWrapper.show();
                                            $digestEmailScheduleStartAtWrapper.show();
                                            break;
                                        case 'every_4_weeks':
                                            $digestEmailSchedulesWrapper.show();
                                            $digestEmailScheduleDaysWrapper.hide();
                                            $digestEmailScheduleWeeklyWrapper.show();
                                            $digestEmailScheduleTimeZoneWrapper.show();
                                            $digestEmailScheduleStartAtWrapper.show();
                                            break;
                                    }
                                }).change();


                                var $digestEmailScheduleDays = $values.digest_email_schedule_days ? $values.digest_email_schedule_days : [];
                                if($digestEmailScheduleDays){
                                    $weeklyDays.prop('checked', false);
                                    $.each($digestEmailScheduleDays, function($i, $v){
                                        $digestEmailScheduleWeeklyWrapper.find(".weekly_days[data-value='"+$v+"']").prop('checked', true);
                                    });
                                }else{
                                    $weeklyDays.prop('checked', false);
                                }
                                $weeklyDays.unbind().change(function(){
                                    var $weeklySelectedDays = [];
                                    $weeklyDays.each(function(){
                                        var $that = $(this);
                                        var $val = $that.data('value');
                                        if($that.prop('checked')){
                                            $weeklySelectedDays.push($val);
                                        }
                                    });
                                    $digestEmailScheduleWeeklyInput.val($weeklySelectedDays.join(','));
                                }).change();

                                $digestEmailScheduleTimeZone.unbind().change(function(){
                                    var $that = $(this);
                                    var $val = $that.val();
                                    var $now = moment().tz($val);
                                    $digestEmailScheduleStartAtWrapper.html($timeZoneChtml).promise().done(function(){
                                        $("#digest-email-schedule-start-at-wrapper").datetimepicker({
                                            defaultDate: $now,
                                            format: 'LT',
                                        });
                                    });
                                });
                                var $digestEmailScheduleStartAt = $values.digest_email_schedule_start_at ? $values.digest_email_schedule_start_at : null;
                                var $now = $digestEmailScheduleStartAt == null ? moment() : moment($digestEmailScheduleStartAt, 'H:mm A');
                                $digestEmailScheduleStartAtWrapper.html($timeZoneChtml).promise().done(function(){
                                    $("#digest-email-schedule-start-at-wrapper").datetimepicker({
                                        defaultDate: $now,
                                        format: 'LT',
                                    });
                                });

                                if($digestEmail == 'On'){
                                    switch($digestEmailSchedulesVal){
                                        case 'daily':
                                            $digestEmailSchedulesWrapper.show();
                                            $digestEmailScheduleDaysWrapper.hide();
                                            $digestEmailScheduleWeeklyWrapper.hide();
                                            $digestEmailScheduleTimeZoneWrapper.show();
                                            $digestEmailScheduleStartAtWrapper.show();
                                            break;
                                        case 'weekly':
                                            $digestEmailSchedulesWrapper.show();
                                            $digestEmailScheduleDaysWrapper.hide();
                                            $digestEmailScheduleWeeklyWrapper.show();
                                            $digestEmailScheduleTimeZoneWrapper.show();
                                            $digestEmailScheduleStartAtWrapper.show();
                                            break;
                                        case 'every_2_weeks':
                                            $digestEmailSchedulesWrapper.show();
                                            $digestEmailScheduleDaysWrapper.hide();
                                            $digestEmailScheduleWeeklyWrapper.show();
                                            $digestEmailScheduleTimeZoneWrapper.show();
                                            $digestEmailScheduleStartAtWrapper.show();
                                            break;
                                        case 'every_3_weeks':
                                            $digestEmailSchedulesWrapper.show();
                                            $digestEmailScheduleDaysWrapper.hide();
                                            $digestEmailScheduleWeeklyWrapper.show();
                                            $digestEmailScheduleTimeZoneWrapper.show();
                                            $digestEmailScheduleStartAtWrapper.show();
                                            break;
                                        case 'every_4_weeks':
                                            $digestEmailSchedulesWrapper.show();
                                            $digestEmailScheduleDaysWrapper.hide();
                                            $digestEmailScheduleWeeklyWrapper.show();
                                            $digestEmailScheduleTimeZoneWrapper.show();
                                            $digestEmailScheduleStartAtWrapper.show();
                                            break;
                                    }
                                }else{
                                    $digestEmailSchedulesWrapper.hide();
                                    $digestEmailScheduleDaysWrapper.hide();
                                    $digestEmailScheduleWeeklyWrapper.hide();
                                    $digestEmailScheduleTimeZoneWrapper.hide();
                                    $digestEmailScheduleStartAtWrapper.hide();
                                }
                                //$accountSettingModal.find("form input[name='talentPoolPhoneNumber']").val($talentPool.phone_number);
                                //$accountSettingModal.find('form input[name="talentPoolZipCode"]').val($talentPool.zip_code);
                                nurseslounge_myDashboard_accountSettings.configuration_dashboard_validate(function ($form) {
                                    var $params = libs.getObjForm($form);
                                    $params = $.extend({},
                                        {action: 'update'},
                                        {user_id: libs.memoryGet('user_id')},
                                        $params,
                                        //{talentPoolEnable:$("#nurseslounge-home-configuration-modal form input[name='talentPoolEnable']").prop('checked')},
                                        {emailNotificationsEnable: $("#emailNotificationsEnableOn").prop('checked')},
                                        {notificationsWindow: $("#notificationsWindowOn").prop('checked')},
                                        {notificationsSound: $("#notificationsSoundOn").prop('checked')},
                                        {disableDismissList: $("#disableDismissListOn").prop('checked')},
                                        {digestEmail: $("#digestEmailOn").prop('checked')},
                                        {password:$password.val()}
                                    );
                                    if($password.val() != ''){
                                        if($password.val() == $rePassword.val()) {
                                            $params = $.extend({}, $params,
                                                {password:$password.val()}
                                            );
                                        }else{
                                            alert("The passwords not match");
                                            return false;
                                        }
                                    }
                                    nurseslounge_myDashboard_accountSettings.configuration_dashboard_getSet($params, function () {
                                        $accountSettingModal.modal('hide');
                                    });
                                });
                            });
                            $("#nurseslounge-home-configuration-modal form .cancel").unbind().click(function () {
                                $accountSettingModal.modal('hide');
                            });
                            $("#nurseslounge-home-configuration-modal select[name='followMe']").unbind().change(function () {
                                if ($(this).val() == 'all') {
                                    $("#nurseslounge-home-configuration-modal .followMe-txt").show();
                                } else {
                                    $("#nurseslounge-home-configuration-modal .followMe-txt").hide();
                                }
                            });
                            if ($("#nurseslounge-home-configuration-modal select[name='followMe']").val() == 'all') {
                                $("#nurseslounge-home-configuration-modal .followMe-txt").show();
                            } else {
                                $("#nurseslounge-home-configuration-modal .followMe-txt").hide();
                            }
                            $("#notificationsWindowOn").unbind().click(function () {
                                if ($(this).prop('checked') && "Notification" in window) {
                                    Notification.requestPermission();
                                }
                            });
                            if ($("#notificationsWindowOn").prop('checked') && "Notification" in window) {
                                Notification.requestPermission();
                            }
                            $accountSettingModal.modal('show');
                        }
                    });
                });
            });
        $deleteMyAccount.unbind().click(function (){
            nurseslounge_myDashboard_accountSettings.configuration_delete_my_account_validate(function ($form) {
                var $params = libs.getObjForm($form);
                $params = $.extend({}, $params, {target:'password', user_id: libs.memoryGet('user_id')});
                nurseslounge_myDashboard_accountSettings.configuration_delete_my_account_request($params, function($data){
                    var $validator = $("#nurseslounge-home-delete-my-account-modal form").validate();
                    var $errors;
                    if($data.data.answer == 1){
                        if(confirm("Changes cannot be reversed if this account is deleted")) {
                            $params = $.extend({}, $params, {target:'erase'});
                            nurseslounge_myDashboard_accountSettings.configuration_delete_my_account_request($params, function($data){
                                window.location = '/logout';
                            });
                        }
                    } else {
                        $errors = {"password": "Invalid Password"};
                    }
                    if($errors){
                        $validator.showErrors($errors);
                    }
                });
            });
            $deleteMyAccountModal.modal('show');
        });
    },
    configuration_dashboard_getSet:function($params, cback){
        $.ajax({
            url: "/myDashboard/header/configuration/getSet",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if(window.location.pathname == '/myDashboard/myProfile') {
                    nurseslounge_myDashboard_myProfile.task_list_container(function($container){
                        nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                    });
                }
                if(window.location.pathname == '/myDashboard/activity') {
                    nurseslounge_myDashboard_activity.task_list_container(function($container){
                        nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                    });
                }
                if(window.location.pathname == '/myDashboard/colleagues') {
                    nurseslounge_myDashboard_colleagues.task_list_container(function($container){
                        nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                    });
                }
                cback($data);
            }
        });
    },
    configuration_dashboard_validate:function(cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-home-configuration-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-home-configuration-modal form").validate({
            onsubmit: true,
            ignore: "*:not(.validate)",
            debug: true,
            rules: {
                followMe: {
                    required: true
                },
                myColleagues: {
                    required: true
                },
                emailNotificationsEnable: {
                    required: true
                },
                groupNotifications: {
                    required: true
                },
                colleaguesNotifications: {
                    required: true
                },
                publisherNotifications: {
                    required: true
                },
                jobNotifications: {
                    required: true
                },
                degreeProgramNotifications: {
                    required: true
                },
                notificationsWindow: {
                    required: true
                },
                notificationsSound:{
                    required: true
                }
            },
            messages: {
                followMe: {
                    required: "The option selected is invalid"
                },
                myColleagues: {
                    required: "The option selected is invalid"
                },
                emailNotificationsEnable: {
                    required: "The email notification is required"
                },
                groupNotifications: {
                    required: "The option selected is invalid"
                },
                colleaguesNotifications: {
                    required: "The option selected is invalid"
                },
                publisherNotifications: {
                    required: "The option selected is invalid"
                },
                jobNotifications: {
                    required: "The option selected is invalid"
                },
                degreeProgramNotifications: {
                    required: "The option selected is invalid"
                },
                notificationsWindow: {
                    required: "The desktop notification is required"
                },
                notificationsSound:{
                    required: "The sound notification is required"
                }
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    configuration_delete_my_account_validate:function(cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-home-delete-my-account-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-home-delete-my-account-modal form").validate({
            onsubmit: true,
            ignore: "*:not(.validate)",
            debug: true,
            rules: {
                password: {
                    required: true
                }
            },
            messages: {
                password: {
                    required: "The password is required"
                },
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    configuration_delete_my_account_request:function($params, cback){
        $.ajax({
            url: "/myDashboard/header/delete/account",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    //Notifications
    notificationUpdate:function($notification){
        var $params = {category:'notifications', user_id:libs.memoryGet('user_id')};
        var $notifications = $("#topNav .notifications-menu .notifications:first");
        var $notificationBell = $notifications.find(".notifications-bell:first");
        var $notificationIcon = $notificationBell.find(".notifications-icon:first");
        if($notification.listen != $notification.viewed){
            $notificationBell.find(".notifications-alert").remove();
            $notificationIcon.after('<span class="badge badge-dark notifications-alert">'+($notification.listen-$notification.viewed)+'</span>').ready(function(){
                nurseslounge_myDashboard_accountSettings.notificationTopNavEvents($params);
            });
        }else{
            $notificationBell.find(".notifications-alert").remove();
            nurseslounge_myDashboard_accountSettings.notificationTopNavEvents($params);
        }
    },
    inboxNotificationUpdate:function($notification){
        var $params = {category:'inboxNotifications', user_id:libs.memoryGet('user_id')};
        var $notifications = $("#topNav .notifications-menu .inbox-notifications:first");
        var $inboxNotificationBell = $notifications.find(".inbox-notifications-bell:first");
        var $inboxNotificationIcon = $inboxNotificationBell.find(".inbox-notification-icon:first");
        if($notification.listen != $notification.viewed){
            $inboxNotificationBell.find(".notifications-alert").remove();
            $inboxNotificationIcon.after('<span class="badge badge-dark notifications-alert">'+($notification.listen-$notification.viewed)+'</span>').ready(function(){
                nurseslounge_myDashboard_accountSettings.inboxNotificationTopNavEvents($params);
            });
        }else{
            $inboxNotificationBell.find(".notifications-alert").remove();
            nurseslounge_myDashboard_accountSettings.inboxNotificationTopNavEvents($params);
        }
        if(window.location.pathname == '/myDashboard/myInbox'){
            nurseslounge_myDashboard_myInbox.inbox_pagination({user_id:libs.memoryGet('user_id')});
            nurseslounge_myDashboard_myInbox.inbox_groups_pagination({user_id:libs.memoryGet('user_id')});
        }
    },

    notificationTopNavEvents:function($params){
        var $notifications = $("#topNav .notifications-menu .notifications:first");
        var $notificationBell = $notifications.find(".notifications-bell:first");
        var $notificationsContainer = $notifications.find(".notifications-container:first .scroller-height:first");
        $notificationBell.unbind().click(function(){
            if(!$notifications.hasClass('show') && $notificationsContainer.length == 1){
                $notificationsContainer.scrollTop(0);
            }
            libs.memorySave('needToView', -1);
            $notificationBell.find(".notifications-alert").remove();
            nurseslounge_myDashboard_accountSettings.notificationTopNavRequest($params);
        }).tooltip();
        nurseslounge_myDashboard_accountSettings.notificationLoad($params, true);
    },
    inboxNotificationTopNavEvents:function($params){
        var $notifications = $("#topNav .notifications-menu .inbox-notifications:first");
        var $inboxNotificationBell = $notifications.find(".inbox-notifications-bell:first");
        var $inboxNotificationsContainer = $notifications.find(".inbox-notifications-container:first .scroller-height:first");
        $inboxNotificationBell.unbind().click(function(){
            if(!$notifications.hasClass('show') && $inboxNotificationsContainer.length == 1){
                $inboxNotificationsContainer.scrollTop(0);
            }
            libs.memorySave('needToViewInboxNotifications', -1);
            $inboxNotificationBell.find(".notifications-alert").remove();
            nurseslounge_myDashboard_accountSettings.notificationTopNavRequest($params);
        }).tooltip();
        nurseslounge_myDashboard_accountSettings.inboxNotificationLoad($params, true);
    },
    //For Both
    notificationTopNavRequest:function($params){
        $.ajax({
            url: "/notifications/topNav/set",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
            }
        });
    },
    notificationLoad:function($params, $withSound){
        var $notificationCookies = nurseslounge_myDashboard_accountSettings.readCookie('notificationCookies');
        $notificationCookies = $notificationCookies ? $notificationCookies.split(',') : [];
        var $notifications = $("#topNav .notifications-menu .notifications:first");
        var $notificationBell = $notifications.find(".notifications-bell:first");
        var $notificationsContainer = $notifications.find(".notifications-container:first");
        var $scrollerHeight = $notificationsContainer.find(".scroller-height:first");
        var $chtml = '';
        nurseslounge_myDashboard_accountSettings.notificationLoadMoreRequest($params, function($data){
            if($notificationsContainer.find('.notification').length == 0){
                var $dropdown = nurseslounge_myDashboard_accountSettings.notificationDropdown($data);
                $notificationBell.after($dropdown).ready(function(){
                    var $numberOfNotifications = $($dropdown).find('.notification').length;
                    var $firstNotification = $($dropdown).find('.notification:first');
                    var $notificationId = $firstNotification.data('id');
                    if($withSound && $notificationId != undefined && $numberOfNotifications == 1){
                        if($.inArray($notificationId, $notificationCookies) == -1){
                            nurseslounge_myDashboard_accountSettings.pushNotificationWithSound($data, $firstNotification[0].outerHTML);
                            $notificationCookies.push($notificationId);
                            nurseslounge_myDashboard_accountSettings.createCookie('notificationCookies',$notificationCookies.join(','),1);
                        }
                    }
                    nurseslounge_myDashboard_accountSettings.notificationOpen($params);
                });
            }else{
                if($data.data.new_notifications.length > 0){
                    var $newNotificationListenArr = [];
                    var $newNotificationListenObj = {};
                    var $newNotificationTag = $scrollerHeight.find(".new-tag:first");
                    for(var $i in $data.data.new_notifications){
                        $newNotificationListenArr.push($($data.data.new_notifications[$i]).data('id'));
                        $newNotificationListenObj[$($data.data.new_notifications[$i]).data('id')] = $data.data.new_notifications[$i];
                    }
                    if($newNotificationTag.length == 0){
                        $chtml = '<h4 class="new-tag">New</h4>';
                        $scrollerHeight.prepend($chtml);
                        $newNotificationTag = $scrollerHeight.find(".new-tag:first");
                    }
                    if($newNotificationTag.nextAll(".notification") != undefined) {
                        $newNotificationTag.nextAll(".notification").each(function () {
                            var $id = $(this).data('id');
                            var $exist = $.inArray($id, $newNotificationListenArr) != -1;
                            if ($exist) {
                                delete $newNotificationListenObj[$id];
                            }
                        });
                    }
                    nurseslounge_myDashboard_accountSettings.notificationOrder($newNotificationListenObj, ".new-tag:first", $withSound, $data,function(){
                        nurseslounge_myDashboard_accountSettings.notificationOpen($params);
                    });
                }
                if($data.data.old_notifications.length > 0){
                    var $oldNotificationListenArr = [];
                    var $oldNotificationListenObj = {};
                    var $oldNotificationTag = $scrollerHeight.find(".old-tag:first");
                    for(var $i in $data.data.old_notifications){
                        $oldNotificationListenArr.push($($data.data.old_notifications[$i]).data('id'));
                        $oldNotificationListenObj[$($data.data.old_notifications[$i]).data('id')] = $data.data.old_notifications[$i];
                    }
                    if($oldNotificationTag.length == 0){
                        $chtml = '<h4 class="old-tag">Old</h4>';
                        $scrollerHeight.append($chtml);
                        $oldNotificationTag = $scrollerHeight.find(".old:first");
                    }
                    if($oldNotificationTag.nextAll(".notification") != undefined) {
                        $oldNotificationTag.nextAll(".notification").each(function () {
                            var $id = $(this).data('id');
                            var $exist = $.inArray($id, $oldNotificationListenArr) != -1;
                            if ($exist) {
                                delete $oldNotificationListenObj[$id];
                            }
                        });
                    }
                    nurseslounge_myDashboard_accountSettings.notificationOrder($oldNotificationListenObj, ".old-tag:first",  false, $data,function(){
                        nurseslounge_myDashboard_accountSettings.notificationOpen($params);
                    });
                }
            }
        });
    },
    inboxNotificationLoad:function($params, $withSound){
        var $inboxNotificationCookies = nurseslounge_myDashboard_accountSettings.readCookie('inboxNotificationCookies');
        $inboxNotificationCookies = $inboxNotificationCookies ? $inboxNotificationCookies.split(',') : [];
        var $notifications = $("#topNav .notifications-menu .inbox-notifications:first");
        var $inboxNotificationBell = $notifications.find(".inbox-notifications-bell:first");
        var $inboxNotificationsContainer = $notifications.find(".inbox-notifications-container:first .scroller-height:first");
        var $scrollerHeight = $inboxNotificationsContainer.find(".scroller-height:first");
        var $chtml = '';
        nurseslounge_myDashboard_accountSettings.notificationLoadMoreRequest($params, function($data){
            if($inboxNotificationsContainer.find('.notification').length == 0){
                var $dropdown = nurseslounge_myDashboard_accountSettings.inboxNotificationDropdown($data);
                $inboxNotificationBell.after($dropdown).ready(function(){
                    var $numberOfNotifications = $($dropdown).find('.notification').length;
                    var $firstNotification = $($dropdown).find('.notification:first');
                    var $notificationId = $firstNotification.data('id');
                    if($withSound && $notificationId != undefined && $numberOfNotifications == 1){
                        if($.inArray($notificationId, $inboxNotificationCookies) == -1){
                            nurseslounge_myDashboard_accountSettings.pushNotificationWithSound($data, $firstNotification[0].outerHTML);
                            $inboxNotificationCookies.push($notificationId);
                            nurseslounge_myDashboard_accountSettings.createCookie('inboxNotificationCookies',$inboxNotificationCookies.join(','),1);
                        }
                    }
                    nurseslounge_myDashboard_accountSettings.inboxNotificationOpen($params);
                });
            }else{
                if($data.data.new_notifications.length > 0){
                    var $newNotificationListenArr = [];
                    var $newNotificationListenObj = {};
                    var $newNotificationTag = $scrollerHeight.find(".new-tag:first");
                    for(var $i in $data.data.new_notifications){
                        $newNotificationListenArr.push($($data.data.new_notifications[$i]).data('id'));
                        $newNotificationListenObj[$($data.data.new_notifications[$i]).data('id')] = $data.data.new_notifications[$i];
                    }
                    if($newNotificationTag.length == 0){
                        $chtml = '<h4 class="new-tag">New</h4>';
                        $scrollerHeight.prepend($chtml);
                        $newNotificationTag = $scrollerHeight.find(".new-tag:first");
                    }
                    if($newNotificationTag.nextAll(".notification") != undefined) {
                        $newNotificationTag.nextAll(".notification").each(function () {
                            var $id = $(this).data('id');
                            var $exist = $.inArray($id, $newNotificationListenArr) != -1;
                            if ($exist) {
                                delete $newNotificationListenObj[$id];
                            }
                        });
                    }
                    nurseslounge_myDashboard_accountSettings.inboxNotificationOrder($newNotificationListenObj, ".new-tag:first", $withSound, $data, function(){
                        nurseslounge_myDashboard_accountSettings.inboxNotificationOpen($params);
                    });
                }
                if($data.data.old_notifications.length > 0){
                    var $oldNotificationListenArr = [];
                    var $oldNotificationListenObj = {};
                    var $oldNotificationTag = $scrollerHeight.find(".old-tag:first");
                    for(var $i in $data.data.old_notifications){
                        $oldNotificationListenArr.push($($data.data.old_notifications[$i]).data('id'));
                        $oldNotificationListenObj[$($data.data.old_notifications[$i]).data('id')] = $data.data.old_notifications[$i];
                    }
                    if($oldNotificationTag.length == 0){
                        $chtml = '<h4 class="old-tag">Old</h4>';
                        $scrollerHeight.append($chtml);
                        $oldNotificationTag = $scrollerHeight.find(".old:first");
                    }
                    if($oldNotificationTag.nextAll(".notification") != undefined) {
                        $oldNotificationTag.nextAll(".notification").each(function () {
                            var $id = $(this).data('id');
                            var $exist = $.inArray($id, $oldNotificationListenArr) != -1;
                            if ($exist) {
                                delete $oldNotificationListenObj[$id];
                            }
                        });
                    }
                    nurseslounge_myDashboard_accountSettings.inboxNotificationOrder($oldNotificationListenObj, ".old-tag:first", false, $data,function(){
                        nurseslounge_myDashboard_accountSettings.inboxNotificationOpen($params);
                    });
                }
            }
        });
    },

    notificationOrder:function($obj, $notification, $withSound, $data, cback){
        var $notificationCookies = nurseslounge_myDashboard_accountSettings.readCookie('notificationCookies');
        $notificationCookies = $notificationCookies ? $notificationCookies.split(',') : [];
        for (var $i in $obj) {
            var $notifications = $("#topNav .notifications-menu .notifications:first");
            var $notificationTag = $notifications.find(".notifications-container:first .scroller-height:first").find($notification);
            var $existingNotifications = [];
            $notifications.find('.notification').each(function(){
                var $that = $(this);
                $existingNotifications.push($that.data('id'));
            });
            if($notificationTag.next(".notification").data('id') == undefined){
                $notificationTag.after($obj[$i]);
                delete $obj[$i];
            }else{
                $notificationTag.nextAll(".notification").each(function() {
                    if(
                        $i > $(this).data('id')
                    ){
                        $(this).before($obj[$i]);
                        var $notificationId = $($obj[$i]).data('id');
                        if(
                            $withSound && $notificationId != undefined &&
                            $.inArray($notificationId, $existingNotifications) == -1 &&
                            $.inArray($notificationId, $notificationCookies) == -1
                        ){
                            nurseslounge_myDashboard_accountSettings.pushNotificationWithSound($data, $obj[$i]);
                            $notificationCookies.push($notificationId);
                            nurseslounge_myDashboard_accountSettings.createCookie('notificationCookies',$notificationCookies.join(','),1);
                        }
                        delete $obj[$i];
                    }else{
                        if(
                            $i < $(this).data('id') &&
                            $i > $(this).next(".notification").data('id') ||
                            $i < $(this).data('id') &&
                            $(this).next(".notification").data('id') == undefined
                        ){
                            $(this).after($obj[$i]);
                            delete $obj[$i];
                        }
                    }
                });
            }
        }
        if(cback != undefined){
            cback();
        }
    },
    inboxNotificationOrder:function($obj, $notification, $withSound, $data, cback){
        var $inboxNotificationCookies = nurseslounge_myDashboard_accountSettings.readCookie('inboxNotificationCookies');
        $inboxNotificationCookies = $inboxNotificationCookies ? $inboxNotificationCookies.split(',') : [];
        for (var $i in $obj) {
            var $notifications = $("#topNav .notifications-menu .inbox-notifications:first");
            var $notificationTag = $notifications.find(".inbox-notifications-container:first .scroller-height:first").find($notification);
            var $existingNotifications = [];
            $notifications.find('.notification').each(function(){
                var $that = $(this);
                $existingNotifications.push($that.data('id'));
            });
            if($notificationTag.next(".notification").data('id') == undefined){
                $notificationTag.after($obj[$i]);
                delete $obj[$i];
            }else{
                $notificationTag.nextAll(".notification").each(function() {
                    if(
                        $i > $(this).data('id')
                    ){
                        $(this).before($obj[$i]);
                        var $notificationId = $($obj[$i]).data('id');
                        if(
                            $withSound && $notificationId != undefined &&
                            $.inArray($notificationId, $existingNotifications) == -1 &&
                            $.inArray($notificationId, $inboxNotificationCookies) == -1
                        ){
                            nurseslounge_myDashboard_accountSettings.pushNotificationWithSound($data, $obj[$i]);
                            $inboxNotificationCookies.push($notificationId);
                            nurseslounge_myDashboard_accountSettings.createCookie('inboxNotificationCookies',$inboxNotificationCookies.join(','),1);
                        }
                        delete $obj[$i];
                    }else{
                        if(
                            $i < $(this).data('id') &&
                            $i > $(this).next(".notification").data('id') ||
                            $i < $(this).data('id') &&
                            $(this).next(".notification").data('id') == undefined
                        ){
                            $(this).after($obj[$i]);
                            delete $obj[$i];
                        }
                    }
                });
            }
        }
        if(cback != undefined){
            cback();
        }
    },

    //For Both
    notificationLoadMoreRequest:function($params, cback){
        $params = $.extend({}, $params, {user_id:libs.memoryGet('user_id')});
        $.ajax({
            url: "/notifications/get",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },

    notificationDropdown:function($data){
        var $chtml = '';
        $chtml+='' +
            '<div class="row dropdown-menu dropdown-menu-right notifications-container">' +
            '   <h3 class="notifications-heading">Notifications</h3>'+
            '   <div class="scroller-height">';
        if($data.data.new_notifications.length > 0){
            $chtml+='' +
                '<h4 class="new-tag">New</h4>' + $data.data.new_notifications.join('');
        }
        if($data.data.old_notifications.length > 0){
            $chtml+='' +
                '<h4 class="old-tag">Old</h4>' + $data.data.old_notifications.join('');
        }
        $chtml+='' +
            '   </div>' +
            '</div>';
        return $chtml;
    },
    inboxNotificationDropdown:function($data){
        var $chtml = '';
        $chtml+='' +
            '<div class="row dropdown-menu dropdown-menu-right inbox-notifications-container">' +
            '   <h3 class="notifications-heading">Messages</h3>'+
            '   <div class="scroller-height">';
        if($data.data.new_notifications.length > 0){
            $chtml+='' +
                '<h4 class="new-tag">New</h4>' + $data.data.new_notifications.join('');
        }
        if($data.data.old_notifications.length > 0){
            $chtml+='' +
                '<h4 class="old-tag">Old</h4>' + $data.data.old_notifications.join('');
        }
        $chtml+='' +
            '   </div>' +
            '</div>';
        return $chtml;
    },
    createCookie:function($name,$value,$days) {
        var $expires;
        if ($days) {
            var $date = new Date();
            $date.setTime($date.getTime()+($days*24*60*60*1000));
            $expires = "; expires="+$date.toGMTString();
        }else{
            $expires = "";
        }
        document.cookie = $name+"="+$value+$expires+"; path=/";
    },
    readCookie:function($name) {
        var $nameEQ = $name + "=";
        var $ca = document.cookie.split(';');
        for(var $i=0;$i < $ca.length;$i++) {
            var $c = $ca[$i];
            while ($c.charAt(0)==' '){
                $c = $c.substring(1,$c.length);
                if ($c.indexOf($nameEQ) == 0){
                    return $c.substring($nameEQ.length,$c.length);
                }
            }
        }
        return null;
    },
    pushNotificationWithSound:function($data, $pushNotification){
        if($pushNotification) {
            if (!$data.data.windows_disable && Notification.permission === "granted") {
                var $title = $($pushNotification).attr('title');
                var $text = $($pushNotification).find('.notify-txt:first').text();
                var $imgSrc = $($pushNotification).find('img:first').attr('src');
                var $url = $($pushNotification).data('url');
                var $notification = new Notification(
                    $title,
                    {
                        body: $text,
                        icon: $imgSrc,
                        silent: true
                    }
                );
                $notification.onclick = function () {
                    router.navigate($url,true);
                };
                if(!$data.data.sounds_disable){
                    var $audio = new Audio('/sounds/notification.mp3');
                    $audio.play();
                }
            }
        }
    },

    notificationOpen:function($params){
        var $notifications = $("#topNav .notifications-menu .notifications:first");
        var $notification = $notifications.find(".notifications-container:first .scroller-height:first .notification");
        $notification.unbind().click(function(){
            var $that = $(this);
            var $notificationId = $that.data('id');
            var $notificationUrl = $that.data('url');
            $params = $.extend({}, $params, {notification_id:$notificationId});
            nurseslounge_myDashboard_accountSettings.notificationSet($params, function(){
                $that.find('.new-notification').remove();
                $that.addClass('opened');
                //router.navigate($notificationUrl,true);
                window.location = $notificationUrl;
            });
        });
        nurseslounge_myDashboard_accountSettings.notificationRealTime();
        nurseslounge_myDashboard_accountSettings.notificationScroll($params);
    },
    inboxNotificationOpen:function($params){
        var $notifications = $("#topNav .notifications-menu .inbox-notifications:first");
        var $notification = $notifications.find(".inbox-notifications-container:first .scroller-height:first .notification");
        $notification.unbind().click(function(){
            var $that = $(this);
            var $notificationId = $that.data('id');
            var $notificationUrl = $that.data('url');
            if(
                window.location.pathname != '/myDashboard/myInbox'
            ) {
                $params = $.extend({}, $params, {notification_id:$notificationId});
                nurseslounge_myDashboard_accountSettings.notificationSet($params, function(){
                    $that.find('.new-notification').remove();
                    $that.addClass('opened');
                    router.navigate($notificationUrl,true);
                });
            }
        });
        nurseslounge_myDashboard_accountSettings.inboxNotificationRealTime();
        nurseslounge_myDashboard_accountSettings.inboxNotificationScroll($params);
    },

    notificationRealTime:function(){
        var $notifications = $("#topNav .notifications-menu .notifications:first");
        var $notificationsContainer = $notifications.find(".notifications-container:first");
        var $notificationsIds = [];
        $notificationsContainer.find(".timestamp").each(function(){
            var $that = $(this);
            $notificationsIds.push($that.data('id'));
        });
        nurseslounge_myDashboard_accountSettings.setNotificationsDates($notificationsIds);
        nurseslounge_myDashboard_accountSettings.notificationsDate();
    },
    inboxNotificationRealTime:function(){
        var $notifications = $("#topNav .notifications-menu .inbox-notifications:first");
        var $notificationsContainer = $notifications.find(".inbox-notifications-container:first");
        var $notificationsIds = [];
        $notificationsContainer.find(".timestamp").each(function(){
            var $that = $(this);
            $notificationsIds.push($that.data('id'));
        });
        nurseslounge_myDashboard_accountSettings.setInboxNotificationsDates($notificationsIds);
        nurseslounge_myDashboard_accountSettings.notificationsDate();
    },

    notifications_dates:[],
    inbox_notifications_dates:[],
    server_date_helper:null,
    server_date:null,
    notification_dates_binding:null,
    setInboxNotificationsDates:function($notificationsIds){
        this.inbox_notifications_dates = $notificationsIds;
    },
    getInboxNotificationsDates:function(){
        return this.inbox_notifications_dates;
    },
    setNotificationsDates:function($notificationsIds){
        this.notifications_dates = $notificationsIds;
    },
    getNotificationsDates:function(){
        return this.notifications_dates;
    },
    setServerDate:function($serverDate){
        this.server_date_helper = new Date();
        this.server_date = new Date($serverDate);
    },
    getServerDate:function(){
        var $now  = new Date().getTime();
        var $diff = $now - this.server_date_helper.getTime();
        var $date = this.server_date.getTime() + $diff;
        return new Date($date);
    },
    notificationsDate:function(){
        $.ajax({
            url:window.location.protocol +'//'+ window.location.hostname + "/",
            method: "GET",
            cache:false,
            dataType: "html",
            success: function ($data, $status, $response) {
                var $dateString = $response.getResponseHeader('date');
                if ($dateString.indexOf('GMT')) {
                    $dateString = $dateString.replace('GMT','');
                }
                nurseslounge_myDashboard_accountSettings.setServerDate($dateString);
                nurseslounge_myDashboard_accountSettings.notificationDateUpdate();
            }
        });
    },
    notificationDateUpdate:function(){
        var $refreshEverySeconds = 1;
        //Notifications
        var $now = nurseslounge_myDashboard_accountSettings.getServerDate().getTime();
        var $notificationDates = nurseslounge_myDashboard_accountSettings.getNotificationsDates();
        var $notifications = $("#topNav .notifications-menu .notifications:first");
        var $notificationsContainer = $notifications.find(".notifications-container:first");
        for(var $i in $notificationDates){
            var $key = $notificationDates[$i];
            var $ele = $notificationsContainer.find('.timestamp[data-id="'+$key+'"]');
            var $val = $ele.data('notificationdate');
            if($ele.length > 0 && $val){
                var $newDate = $val.split(' ');
                var $yearMonthDay = $newDate[0];
                $yearMonthDay = $yearMonthDay.split('-');
                var $HourMinuteSecond = $newDate[1];
                $HourMinuteSecond = $HourMinuteSecond.split(':');
                var $date = new Date($yearMonthDay[0], $yearMonthDay[1] - 1, $yearMonthDay[2], $HourMinuteSecond[0], $HourMinuteSecond[1], $HourMinuteSecond[2]);
                var $second = $date.getSeconds();
                $second = $second <= 9 ? '0' + $second : $second;
                var $minute = $date.getMinutes();
                $minute = $minute <= 9 ? '0' + $minute : $minute;
                var $hour = $date.getHours();
                $hour = $hour <= 9 ? '0' + $hour : $hour;
                var $day = $date.getDate();
                $day = $day <= 9 ? '0' + $day : $day;
                var $month = $date.getMonth() + 1;
                $month = $month <= 9 ? '0' + $month : $month;
                var $year = $date.getFullYear();
                var $_notificationDate =  $year + '-' + $month + '-' + $day + ' ' + $hour + ':'+ $minute + ':' + $second;
                $date = $date.getTime();
                var $diffSeconds = Math.floor(($now - $date)/1000);
                var $diffMinutes = Math.floor($diffSeconds/60);
                var $diffHours = Math.floor($diffMinutes/60);
                var $diffDays = Math.floor($diffHours/24);
                var $chtml = '';
                if($diffDays == 0 && $diffHours == 0 && $diffMinutes == 0){
                    $chtml = $diffSeconds == 1 ? $diffSeconds + ' second ago' : $diffSeconds + ' seconds ago';
                }else
                if ($diffDays == 0 && $diffHours == 0){
                    $chtml = $diffMinutes == 1 ? $diffMinutes + ' minute ago' : $diffMinutes + ' minutes ago';
                }else
                if ($diffDays == 0){
                    $chtml = $diffHours == 1 ? $diffHours + ' hour ago' : $diffHours + ' hours ago';
                }else
                if($diffDays < 4){
                    $chtml = $diffDays == 1 ? $diffDays + ' day ago' : $diffDays + ' days ago';
                }else{
                    $date = $notificationsContainer.find('.timestamp[data-id="'+$key+'"]').data('notificationdate');
                    $chtml =  moment.utc($date, 'YYYY-MM-DD HH:mm:ss').local().format('MMMM, DD YYYY hh:mm A');
                }
                if($ele.html() != $chtml){
                    $ele.data('notificationdate', $_notificationDate).html($chtml);
                }
            }
        }
        nurseslounge_myDashboard_accountSettings.inboxNotificationDateUpdate($now);
        try{
            clearTimeout(this.notification_dates_binding);
        }catch($e){}
        this.notification_dates_binding = setTimeout(function(){
            nurseslounge_myDashboard_accountSettings.notificationDateUpdate();
        }, ($refreshEverySeconds * 1000));
    },
    inboxNotificationDateUpdate:function($now){
        //Inbox Notifications
        var $inboxNotificationDates = nurseslounge_myDashboard_accountSettings.getInboxNotificationsDates();
        var $inboxNotifications = $("#topNav .notifications-menu .inbox-notifications:first");
        var $inboxNotificationsContainer = $inboxNotifications.find(".inbox-notifications-container:first");
        for(var $i in $inboxNotificationDates){
            var $key = $inboxNotificationDates[$i];
            var $ele = $inboxNotificationsContainer.find('.timestamp[data-id="'+$key+'"]');
            var $val = $ele.data('notificationdate');
            if($ele.length > 0 && $val){
                var $newDate = $val.split(' ');
                var $yearMonthDay = $newDate[0];
                $yearMonthDay = $yearMonthDay.split('-');
                var $HourMinuteSecond = $newDate[1];
                $HourMinuteSecond = $HourMinuteSecond.split(':');
                var $date = new Date($yearMonthDay[0], $yearMonthDay[1] - 1, $yearMonthDay[2], $HourMinuteSecond[0], $HourMinuteSecond[1], $HourMinuteSecond[2]);
                var $second = $date.getSeconds();
                $second = $second <= 9 ? '0' + $second : $second;
                var $minute = $date.getMinutes();
                $minute = $minute <= 9 ? '0' + $minute : $minute;
                var $hour = $date.getHours();
                $hour = $hour <= 9 ? '0' + $hour : $hour;
                var $day = $date.getDate();
                $day = $day <= 9 ? '0' + $day : $day;
                var $month = $date.getMonth() + 1;
                $month = $month <= 9 ? '0' + $month : $month;
                var $year = $date.getFullYear();
                var $_notificationDate =  $year + '-' + $month + '-' + $day + ' ' + $hour + ':'+ $minute + ':' + $second;
                $date = $date.getTime();
                var $diffSeconds = Math.floor(($now - $date)/1000);
                var $diffMinutes = Math.floor($diffSeconds/60);
                var $diffHours = Math.floor($diffMinutes/60);
                var $diffDays = Math.floor($diffHours/24);
                var $chtml = '';
                if($diffDays == 0 && $diffHours == 0 && $diffMinutes == 0){
                    $chtml = $diffSeconds == 1 ? $diffSeconds + ' second ago' : $diffSeconds + ' seconds ago';
                }else
                if ($diffDays == 0 && $diffHours == 0){
                    $chtml = $diffMinutes == 1 ? $diffMinutes + ' minute ago' : $diffMinutes + ' minutes ago';
                }else
                if ($diffDays == 0){
                    $chtml = $diffHours == 1 ? $diffHours + ' hour ago' : $diffHours + ' hours ago';
                }else
                if($diffDays < 4){
                    $chtml = $diffDays == 1 ? $diffDays + ' day ago' : $diffDays + ' days ago';
                }else{
                    $date = $inboxNotificationsContainer.find('.timestamp[data-id="'+$key+'"]').data('notificationdate');
                    $chtml =  moment.utc($date, 'YYYY-MM-DD HH:mm:ss').local().format('MMMM, DD YYYY hh:mm A');
                }
                if($ele.html() != $chtml){
                    $ele.data('notificationdate', $_notificationDate).html($chtml);
                }
            }
        }
    },
    //For Both
    notificationSet:function($params, cback){
        $.ajax({
            url: "/notifications/set",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },

    notificationScroll:function($params){
        var $notifications = $("#topNav .notifications-menu .notifications:first");
        var $notificationsContainer = $notifications.find(".notifications-container:first");
        var $scrollerHeight = $notificationsContainer.find(".scroller-height:first");
        var $loadMoreAfterPercent = 25;
        var $scrollBinding;
        $scrollerHeight.unbind().scroll(function() {
            var $maxScrollTop = $scrollerHeight[0].scrollHeight - $scrollerHeight.height();
            var $actualScroll = $scrollerHeight.scrollTop();
            var $triggerPercent = ($actualScroll * 100) / $maxScrollTop > $loadMoreAfterPercent;
            if ($triggerPercent) {
                try {
                    clearTimeout($scrollBinding);
                }catch (e) {
                }
                $scrollBinding = setTimeout(function(){
                    $notifications = $("#topNav .notifications-menu .notifications:first");
                    $notificationsContainer = $notifications.find(".notifications-container:first");
                    $scrollerHeight = $notificationsContainer.find(".scroller-height:first");
                    var $offset = $scrollerHeight.find(".notification").length;
                    $params = $.extend({}, $params, {offset:$offset});
                    nurseslounge_myDashboard_accountSettings.notificationLoad($params, false);
                }, 800);
            }
        });
    },
    inboxNotificationScroll:function($params){
        var $notifications = $("#topNav .notifications-menu .inbox-notifications:first");
        var $inboxNotificationsContainer = $notifications.find(".inbox-notifications-container:first");
        var $scrollerHeight = $inboxNotificationsContainer.find(".scroller-height:first");
        var $loadMoreAfterPercent = 25;
        var $scrollBinding;
        $scrollerHeight.unbind().scroll(function() {
            var $maxScrollTop = $scrollerHeight[0].scrollHeight - $scrollerHeight.height();
            var $actualScroll = $scrollerHeight.scrollTop();
            var $triggerPercent = ($actualScroll * 100) / $maxScrollTop > $loadMoreAfterPercent;
            if ($triggerPercent) {
                try {
                    clearTimeout($scrollBinding);
                }catch (e) {
                }
                $scrollBinding = setTimeout(function(){
                    $notifications = $("#topNav .notifications-menu .inbox-notifications");
                    $inboxNotificationsContainer = $notifications.find(".inbox-notifications-container:first");
                    $scrollerHeight = $inboxNotificationsContainer.find(".scroller-height:first");
                    var $offset = $scrollerHeight.find(".notification").length;
                    $params = $.extend({}, $params, {offset:$offset});
                    nurseslounge_myDashboard_accountSettings.inboxNotificationLoad($params, false);
                }, 800);
            }
        });
    },
    //Coins
    coins:function($params){
        var $savedCoins = nurseslounge_myDashboard_accountSettings.readCookie('COINS');
        nurseslounge_myDashboard_accountSettings.coins_request($params, function($data){
            var $coinsTotal = $data.data.coins_total;
            if($savedCoins != null){
                if($savedCoins != $coinsTotal){
                    var $audio = new Audio('/sounds/coins.mp3');
                    $audio.play();
                }
                $(".target-coins").html($coinsTotal).promise().done(function(){
                    nurseslounge_myDashboard_accountSettings.createCookie('COINS', $coinsTotal,100);
                });
            }
        });
    },
    coins_request:function($params, cback){
        $.ajax({
            url: "/myDashboard/header/coins/get",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    //Shop
    shop:function(){
        var $topNav = $("#topNav");
        var $coinsBasket =  $topNav.find('.coins-basket');
        var $modal = $("#nurseslounge-shop-modal");
        $coinsBasket.unbind().click(function(){
            var $allowTabs = {
                'theShop':  true,
                'dailyQuests':  false,
                'dailyLoginRewards':  false,
            };
            var $allowTabsFiltered = $allowTabs;
            $allowTabs = {};
            $.each($allowTabsFiltered, function($k, $v) {var $newObj = {};$newObj[$k]=$v;if($v){$.extend($allowTabs, $newObj);}});
            var $tab = null;
            $.each($allowTabs, function($i, $v){
                if($v){
                    $tab = $i;
                    return false;
                }
            });
            nurseslounge_myDashboard_accountSettings.select_tab($tab, $allowTabs, function(){
                $modal.scrollTop(0);
                $modal.modal('show');
            });
        });
    },
    select_tab_events:function($tab, $allowTabs, cback){
        //Disable All
        $('#nurseslounge-shop-modal .nav-pills .nav-link').addClass('disabled').removeClass('active');
        $('#nurseslounge-shop-modal .shop-container .tab-pane .container').html('');
        //Events
        $('#nurseslounge-shop-modal .nav-pills a[data-toggle="tab"]').unbind().on('shown.bs.tab', function ($e) {
            var $selectedTab = $e.currentTarget.dataset.target.replace('#','');
            if($.inArray($selectedTab, Object.keys($allowTabs)) > -1){
                nurseslounge_myDashboard_accountSettings.select_tab($selectedTab, $allowTabs, function(){
                    $("#nurseslounge-shop-modal").scrollTop(0);
                });
            }
        });
        //Enable selected
        $.each($allowTabs, function ($i, $v) {
            $("#"+$v).removeClass('active').removeClass('show');
            $('#nurseslounge-shop-modal .nav-pills .nav-link[data-target="#'+$i+'"]').removeClass('disabled');
        });
        $('#nurseslounge-shop-modal .nav-pills .nav-link[data-target="#'+$tab+'"]').addClass('active');
        $("#"+$tab).addClass('active').addClass('show');
        if(cback != undefined){
            cback();
        }
    },
    select_tab:function($selectedTab, $allowTabs, cback){
        nurseslounge_myDashboard_accountSettings.select_tab_events($selectedTab, $allowTabs, function(){
            nurseslounge_myDashboard_accountSettings.load_tab($selectedTab,function() {
                switch ($selectedTab) {
                    case 'theShop':
                        nurseslounge_myDashboard_accountSettings.the_shop(cback);
                        break;
                }
            });
        });
    },
    load_tab:function($selectedTab, cback){
        nurseslounge_myDashboard_accountSettings.get_tab($selectedTab, function($chtml){
            var $images = $($chtml).find('img');
            libs.checkImageLoad($images, function(){
                $("#"+$selectedTab+" .container").html($chtml).promise().done(function(){
                    if(cback != undefined){
                        cback();
                    }
                });
            });
        });
    },
    get_tab:function($selectedTab, cback){
        var $userId = libs.memoryGet('user_id');
        $.ajax({
            type: 'POST',
            url: '/myDashboard/header/shop',
            data: {user_id:$userId,tab:$selectedTab},
            method: "POST",
            cache:false,
            dataType: "html",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    the_shop:function(cback){
        var $cards = $("#theShop .container .nurseslounge-item-cards");
        var $chtml = nurseslounge_myDashboard_accountSettings.the_shop_items_preview();
        $cards.html($chtml).promise().done(function(){
            nurseslounge_myDashboard_accountSettings.the_shop_items_request(function($data){
                var $chtml = nurseslounge_myDashboard_accountSettings.the_shop_items_html($data);
                libs.checkImageLoad($($chtml).find('img'), function(){
                    $cards.html($chtml).promise().done(function(){
                        $cards.find('.carousel').hide();
                        nurseslounge_myDashboard_accountSettings.the_shop_events(function(){
                            cback();
                        });
                    });
                });
            });
        });
    },
    the_shop_items_preview:function(){
        var $chtml = '';
        for(var $i=0; $i<2; $i++){
            $chtml += '' +
                '<div class="col-6 item float-left">' +
                '    <div class="card article-card mb-4">' +
                '        <div class="article-card-image items-preload">' +
                '                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '        </div>' +
                '        <div class="article-card-desc px-3 items-preload">' +
                '                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '        </div>' +
                '        <div class="article-card-footer px-3 items-preload">' +
                '                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '        </div>' +
                '    </div>' +
                '</div>';
        }
        return $chtml;
    },
    the_shop_items_request:function(cback){
        var $userId = libs.memoryGet('user_id');
        $.ajax({
            url: "/myDashboard/header/shop/items",
            method: "POST",
            cache:false,
            dataType: "json",
            data: {user_id:$userId},
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success'){
                    cback($data);
                }
            }
        });
    },
    the_shop_items_html:function($data){
        var $chtml = '<div class="row col-10 offset-1 carousel">';
        $.each($data.data.items, function($i, $v){
            var $id = $v.id;
            var $title = $v.title;
            var $description = $v.description;
            var $itemImageRoot = $v.item_image_root;
            var $cost = $v.cost;
            $chtml += '' +
                '<div class="col-12 item" data-id="'+$id+'">' +
                '     <div class="card article-card mb-4">' +
                '         <div class="article-card-image">' +
                '             <img src="'+$itemImageRoot+'" alt="article image" class="img-fluid">' +
                '         </div>' +
                '         <div class="article-card-desc px-3">' +
                '             <h3>'+$title+'</h3>' +
                '             <p>'+$description+'</p>' +
                '         </div>' +
                '         <div class="article-card-footer px-3">' +
                '             <div class="left"></div>' +
                '             <div class="right">' +
                '                 <div>' +
                '                     <img src="/bimg/NursesLounge/basket.png" class="img-fluid">' +
                '                 </div>' +
                '                 <div class="cost">'+$cost+'</div>' +
                '             </div>' +
                '         </div>' +
                '     </div>' +
                ' </div>';
        });
        $chtml += '</div>';
        return $chtml;
    },
    the_shop_events:function(cback){
        var $carousels = $("#theShop .container .nurseslounge-item-cards .carousel");
        $carousels.unbind();
        $carousels.slick({
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
        setTimeout(function(){
            $carousels.slick('refresh');
            $carousels.find('.item').click(function(){
                var $that = $(this);
                var $id = $that.data('id');
                nurseslounge_myDashboard_accountSettings.the_shop_open_item($id);
            });
            $carousels.fadeIn();
        }, 600);
        cback();
    },
    the_shop_open_item:function($id){
        var $userId = libs.memoryGet('user_id');
        var $params = $.extend({}, {id:$id, user_id:$userId});
        var $cards = $("#theShop .container .nurseslounge-item-cards");
        var $purchaseCards = $("#theShop .container .nurseslounge-item-purchase-cards");
        nurseslounge_myDashboard_accountSettings.the_shop_open_item_purchase_request($params, function($chtml){
            libs.checkImageLoad($($chtml).find('img'), function(){
                $cards.hide();
                $purchaseCards.html($chtml).promise().done(function(){
                    $purchaseCards = $("#theShop .container .nurseslounge-item-purchase-cards");
                    var $back = $purchaseCards.find('.back');
                    $back.unbind().click(function(){
                        $purchaseCards.html('');
                        $cards.fadeIn();
                    });
                    var $buy = $purchaseCards.find('.buy');
                    $buy.unbind().click(function(){
                        nurseslounge_myDashboard_accountSettings.the_shop_open_item_purchase_set_request($params, function($data){
                            $params = $.extend({}, $params, {code:$data.data.code});
                            nurseslounge_myDashboard_accountSettings.coins({user_id:$userId});
                            nurseslounge_myDashboard_accountSettings.the_shop_open_item_purchase_complete_request($params, function($chtml){
                                $purchaseCards.html($chtml).promise().done(function(){
                                    $purchaseCards = $("#theShop .container .nurseslounge-item-purchase-cards");
                                    var $continue = $purchaseCards.find('.continue');
                                    $continue.unbind().click(function(){
                                        $purchaseCards.html('');
                                        nurseslounge_myDashboard_accountSettings.the_shop(function(){
                                            $cards.fadeIn();
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    },
    the_shop_open_item_purchase_request:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/myDashboard/header/shop/items/purchase',
            data: $params,
            method: "POST",
            cache:false,
            dataType: "html",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    the_shop_open_item_purchase_set_request:function($params, cback){
        $.ajax({
            url: "/myDashboard/header/shop/items/purchase/set",
            method: "POST",
            cache:false,
            dataType: "json",
            data: $params,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success'){
                    cback($data);
                }
            }
        });
    },
    the_shop_open_item_purchase_complete_request:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/myDashboard/header/shop/items/purchase/complete',
            data: $params,
            method: "POST",
            cache:false,
            dataType: "html",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    //Mobile
    mobile:function(){
        if(libs.isAndroid()){
            var $modal = $("#nurseslounge-android-mobile-modal");
            $modal.modal('show');
        }
    }
};
